import { Alert, AlertTitle } from '@mui/material'
import { UserSubscription } from 'types'
import { formatDate } from 'utils'
import { getPlanDisplayName } from '../constants'
import { isPartnerFunded } from '../utils'

/**
 * Why the user landed on the paywall. Spelled out on purpose: a locked account with no
 * explanation reads as a broken app, not as an expired subscription.
 * Past Due stays on My Subscription, so this notice is only for a subscription that ended.
 */
export function ExpiredSubscriptionNotice({ subscription }: { subscription: UserSubscription }) {
  const endDate = formatDate(subscription.currentPeriodEnd, 'MM.DD.YY')

  if (isPartnerFunded(subscription)) {
    return (
      <Alert severity="warning">
        <AlertTitle>Your Partner-Funded Family Subscription has expired</AlertTitle>
        Partner-funded access ended on {endDate}. Your account is kept — choose a subscription plan
        below to continue.
      </Alert>
    )
  }

  return (
    <Alert severity="warning">
      <AlertTitle>Your subscription has ended</AlertTitle>
      Your {getPlanDisplayName(subscription.plan)} ended on {endDate}. Your account is kept — choose
      a subscription plan below to continue.
    </Alert>
  )
}
